module.exports = __webpack_public_path__ + "static/Lamentum1-8afb0aea6cb749f502eb174ad8c53f73.png";